import {styled} from "@mui/material/styles"
import {Box} from "@mui/material"
import {breakpoints, FALLBACK_FONT_FAMILY} from "@next/ux-fabric"
import {Container} from "../../component"

export const StyledContainer = styled(Container, {
    shouldForwardProp: prop => prop !== "xxlBreakpointEnabled",
})<{xxlBreakpointEnabled: boolean}>`
    letter-spacing: ${({theme}) => theme.uxfabric.component.buttonMedium.letterSpacing}px;
    font-family: ${({theme}) => theme.uxfabric.component.buttonMedium.fontFamily}, ${FALLBACK_FONT_FAMILY} !important;
    font-size: ${({theme}) => theme.uxfabric.component.buttonMedium.fontSize};
    font-weight: ${({theme}) => theme.uxfabric.component.buttonMedium.fontWeight};
    height: 2.75rem;
    min-width: 8.125rem;
    ${({xxlBreakpointEnabled}) =>
        xxlBreakpointEnabled &&
        `@media (min-width: ${breakpoints.values.xxl}px) {
            min-width: 12.5rem;
        }`}
`

export const StyledBox = styled(Box)`
    height: 100%;
    font-family: inherit !important;
    font-weight: inherit !important;
    font-size: inherit !important;
    letter-spacing: inherit !important;
`
